<template>
  <div class="company">
    <div class="company-imgs">
      <div>
        <img src="@/assets/img/customize.png" alt="" />
        <div>量身定制</div>
      </div>
      <div>
        <img src="@/assets/img/development.png" alt="" />
        <div>自主研发</div>
      </div>
      <div>
        <img src="@/assets/img/one_place.png" alt="" />
        <div>一站服务</div>
      </div>
      <div>
        <img src="@/assets/img/more_industry.png" alt="" />
        <div>多样行业</div>
      </div>
    </div>
    <div class="company-culture company-culture-height">
      <!-- <img src="@/assets/img/banner_01.png" alt="" /> -->
      <div class="company-culture-img"></div>
      <div class="company-culture-cover"></div>
      <div class="company-culture-content">
        <div class="content">
          <div class="content-title">公司文化</div>
          <div class="content-title-tips">Company Culture</div>
        </div>
        <div class="culture-box">
          <div class="one-box box">
            <div class="box-text">
              <div class="box-text-title">企业文化价值观</div>
              <div class="box-text-cont">
                以“客户至上、安全合规、人文关怀”为核心价值观，所有技师均需通过国家级资质认证与背景调查，并完成标准化培训，确保服务流程严格遵循《上门推拿服务规范》。平台“隐私三重防护体系”，从双向身份核验到服务全程录音加密，让用户享受居家按摩时安全感提升76%。员工关怀上推行“双通道晋升+心理健康支持”，技师可自主选择职业发展方向，平台年度投入超百万元用于渠道扩大。
              </div>
            </div>
          </div>
          <div class="two-box box">
            <div class="box-text">
              <div class="box-text-title">多行业拓展​</div>
              <div class="box-text-cont">
                跨界融合创造增量价值，通过不同行业合作和平台衍生行业，形成多维行业，相互融合创造更多可能性，不断拓界突破行业限制。
              </div>
            </div>
          </div>
          <div class="three-box box">
            <div class="box-text">
              <div class="box-text-title">社会责任</div>
              <div class="box-text-cont">
                商业向善的可持续发展​，对社会进行反哺，与社会共同进步，并同步为中小创业者提供数字化管理系统合作模式。
              </div>
            </div>
          </div>
          <div class="four-box box">
            <div class="box-text">
              <div class="box-text-title">未来愿景</div>
              <div class="box-text-cont">
                未来三年，我们将以服务技术质量重构服务场景——通过系统智能实时监测用户服务质量，动态调整服务和按摩方案，同步启动“百城千店”计划，与全国3000+高端酒店、健身中心建立场景化合作，让24小时即时服务覆盖80%地级市。预计2028年建成“按摩+康复+健康管理”的一站式数字平台。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="News-box box-class">
      <div class="News-title">公司风貌</div>
      <div class="News-title-tips">Company Style</div>
    </div>
    <div class="company-swiper">
      <div class="my-container">
        <swiper
          v-if="carouselList.length > 0"
          :options="swiperOption"
          ref="mySwiper"
          class="mySwiper"
        >
          <swiper-slide
            v-for="(item, index) in carouselList"
            :key="index"
            class="swiper-slide"
          >
            <div class="slide-content">
              <img :src="item.imgUrl" />
              <div class="slide-title">{{ item.title }}</div>
            </div>
          </swiper-slide>

          <!-- 左右箭头 -->
          <!-- <div slot="button-prev" class="swiper-button-prev"></div>
        <div slot="button-next" class="swiper-button-next"></div> -->

          <!-- 如果需要分页器，可以添加以下代码 -->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Company",
  data() {
    return {
      name: "公司简介",
      carouselList: [
        {
          id: 1,
          imgUrl: require("@/assets/img/banner_01.png"),
          title: "Slide 1",
        },
        {
          id: 2,
          imgUrl: require("@/assets/img/banner_01.png"),
          title: "Slide 2",
        },
        {
          id: 3,
          imgUrl: require("@/assets/img/banner_01.png"),
          title: "Slide 3",
        },
        {
          id: 4,
          imgUrl: require("@/assets/img/banner_01.png"),
          title: "Slide 4",
        },
        {
          id: 5,
          imgUrl: require("@/assets/img/banner_01.png"),
          title: "Slide 5",
        },
        // 添加更多slide数据
      ],
      swiperOption: {
        // 异形轮播效果，例如使用'coverflow'效果
        effect: "coverflow",
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 0,
          slideShadows: true,
        },
        // 启用缩放效果
        zoom: {
          maxRatio: 2, // 设置最大缩放比例
          minRatio: 1, // 设置最小缩放比例
        },
        // 其他配置项
        centeredSlides: true,
        slidesPerView: 3,
        speed: 300, // 切换动画时长为300ms
        // Coverflow 特效参数
        coverflowEffect: {
          rotate: 0, // 关闭幻灯片旋转效果
          stretch: 0, // 关闭幻灯片拉伸效果
          depth: 0, // 关闭幻灯片深度偏移
          modifier: 3, // 缩放比例乘数（影响相邻幻灯片大小差异）
          slideShadows: false, // 禁用幻灯片的投影效果
        },
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        //导航前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 如果需要分页器，可以取消以下代码的注释
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          //修改分页器样式
          bulletClass: "swiper-pagination-bullet",
          //激活样式
          bulletActiveClass: "my-bullet-active",
          dynamicBullets: false, // 必须关闭动态分页
        },
        on: {
          // slideChange: ()=> {
          //   // 普通函数保持this指向组件实例
          //   if (this.$refs.mySwiper.$swiper) {
          //     // 可选链操作符增加安全性
          //     let {realIndex} = this.$refs.mySwiper.$swiper
          //     console.log(realIndex)
          //   }
          // },
        },
      },
    };
  },
  mounted() {
    console.log("MyComponent mounted"); // 输出：MyComponent mounted
    setInterval(() => {
      if (this.aniIndex > 3) {
        this.aniIndex = 0;
      } else {
        this.aniIndex++;
      }
    }, 3000);
  },
};
</script>

<style lang="less" scoped>
.company {
  background-color: #f1f0ec;
  overflow: hidden;
}

.company-imgs {
  width: 80%;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 auto;
  padding: 0.7905rem 0;
  font-size: 16px;
  box-sizing: border-box;

  img {
    width: 1.8972rem;
    height: 1.8972rem;
    min-width: 100px;
    min-height: 100px;
    border-radius: 50%;
    margin: 10px 20px;
    margin-top: 20px;
  }
}

.company-culture {
  width: 100%;
  position: relative;

  .company-culture-img {
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/img/banner_01.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }

  .company-culture-cover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .company-culture-content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;

    .content {
      width: 100%;
      height: 30%;
      max-height: 120px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 35px 0;

      .content-title {
        font-size: 0.4743rem;
        font-weight: bold;
        color: #fff;
        padding: 5.0031px 6.0024px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.4);
      }

      .content-title-tips {
        font-size: 0.1897rem;
        color: rgba(255, 255, 255, 0.8);
        margin-top: 0.0791rem;
      }
    }

    .culture-box {
      width: 70%;
      height: auto;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-wrap: wrap;
      margin: 0 auto;

      .one-box {
        flex-basis: 60%;
        border-bottom: 1px solid rgb(255, 255, 255);
        border-right: 1px solid rgb(255, 255, 255);
      }

      .two-box {
        flex-basis: 40%;
        border-bottom: 1px solid rgb(255, 255, 255);
        border-left: 1px solid rgb(255, 255, 255);
      }

      .three-box {
        flex-basis: 40%;
        border-top: 1px solid rgb(255, 255, 255);
        border-right: 1px solid rgb(255, 255, 255);
      }

      .four-box {
        flex-basis: 60%;
        border-top: 1px solid rgb(255, 255, 255);
        border-left: 1px solid rgb(255, 255, 255);
      }

      .box {
        min-width: 210px;
        height: 160px;
        min-height: 120px;
        box-sizing: border-box;
        box-sizing: border-box;
        overflow: hidden;

        .box-text {
          border: 1px solid rgb(255, 255, 255);
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: #fff;
          padding: 0px 20px;

          .box-text-title {
            font-size: 18px;
            margin-bottom: 10px;
          }

          .box-text-cont {
            color: #dfdfdf;
            text-align: left;
            font-size: 12px;
            text-indent: 2em;
          }
        }
      }
    }
  }
}

/* 屏幕宽度小于768px时 */
@media screen and (max-width: 768px) {
  .company-culture-height {
    height: 800px;

    .box {
      flex-basis: 100% !important;
    }

    .box-text {
      width: calc(100% - 22px);
      height: calc(100% - 22px);
      margin: 10px;

      .box-text-title {
        font-size: 12px !important;
        margin-bottom: 5px;
      }

      .box-text-cont {
        color: #dfdfdf;
        text-align: left;
        font-size: 8px !important;
      }
    }
  }
}

/* 屏幕宽度大于768px时 */
@media screen and (min-width: 768px) {
  .company-culture-height {
    height: 500px;

    .company-culture-img {
      background-size: contain;
    }

    .box:nth-child(1) {
      .box-text {
        margin: 0 10px 10px 0;
      }
    }

    .box-text {
      width: calc(100% - 12px);
      height: calc(100% - 12px);
    }

    .box:nth-child(2) {
      .box-text {
        margin: 0 0 10px 10px;
      }
    }

    .box:nth-child(3) {
      .box-text {
        margin: 10px 10px 0 0;
      }
    }

    .box:nth-child(4) {
      .box-text {
        margin: 10px 0 0 10px;
      }
    }
  }
}

/* 屏幕宽度大于768px时 */
@media screen and (min-width: 1280px) {
  .company-culture-height {
    height: 600px;
  }
}

.News-box {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 35px 0 0 0;

  .News-title {
    font-size: 0.4743rem;
    font-weight: bold;
    color: #333;
    padding: 5.0031px 6.0024px;
    border-bottom: 1px solid rgba(26, 158, 101, 0.4);
  }

  .News-title-tips {
    font-size: 0.1897rem;
    color: rgba(26, 158, 101, 0.8);
    margin-top: 0.0791rem;
  }

  .News-service {
    font-size: 0.253rem;
    font-weight: 500;
    margin-top: 20px;
  }

  .News-picture {
    width: 8.6957rem;
    height: 4.7431rem;
    min-width: 275px;
    min-height: 190px;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;

    img {
      width: 35%;
      min-width: 100px;
      height: 40%;
      min-height: 80px;
      margin: 0.1581rem 0.3162rem;
      border-radius: 10px;
    }
  }
}

.box-class {
  background-color: #ffffff;
}

.company-swiper {
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;

  .my-container {
    width: 90vw;
    height: 4.7431rem;
    min-height: 130px;
    overflow: hidden;
    margin: 0.4743rem auto;

    .mySwiper {
      width: 100%;
      height: 100%;

      .swiper-slide {
        // width: 25% !important;
        height: 100%;
        /* 根据需要自定义slide的样式 */
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        // background-color: #fff;
        transform: scale(0.8) !important;

        .slide-content {
          width: 100%;
          height: 90%;
          text-align: center;
          position: relative;

          img {
            width: 100%;
            height: auto;
            border-radius: 0.1581rem;
          }

          .slide-title {
            margin-top: 0.1581rem;
            font-size: 0.2846rem;
            font-weight: bold;
            color: #fff;
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
          }
        }
      }

      .swiper-slide-active {
        transform: scale(1) !important;
      }
    }
  }
}

.swiper-button-prev::after,
.swiper-button-next::after {
  font-size: 0.3162rem;
  font-weight: bold;
}

.swiper-button-prev {
  left: 0.1581rem;
}

.swiper-button-next {
  right: 0.1581rem;
}
</style>

<style type="text/css">
.swiper-pagination-bullet {
  width: 0.5375rem;
  height: 0.253rem;
  opacity: 0.2;
  margin: 0 5px;
  border-radius: 20px;
  transition: opacity 0.5s, background-color 0.5s, width 0.5s !important;
  transition-delay: 0.5s, 0.5s, 0s;
  background-color: #999999;
}
.my-bullet-active {
  opacity: 1;
  background-color: #666666;
  width: 1.7866rem;
  transition-delay: 0s;
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Company.vue